import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        name: "Init",
        // component: () => {
        //     return import("../App.vue")
        // },
        redirect: "/index",
        meta: {
            active: "Init",
            permissionCode: "index",
        },
    },
    {
        path: "/index",
        name: "Index",
        component: () => {
            return import(/* webpackChunkName: "index-page" */ "../pages/Index/")
        },
        meta: {
            active: "Index",
            permissionCode: "index",
        },
    },
    {
        path: "/buy-package",
        name: "BuyPackage",
        component: () => {
            return import(/* webpackChunkName: "index-page" */ "../pages/Index/buyPackage.vue")
        },
        meta: {
            noAppNav: true,
        },
    },
    {
        path: "/station-management",
        name: "StationManagement",
        component: () =>
            import(
                /* webpackChunkName: "station-management" */ "../pages/StationManagement/"
                ),
        meta: {
            active: "StationManagement",
            permissionCode: "admin:org",
        },
    },
    {
        path: "/station-management/add-station/:id/:type",
        name: "AddStation",
        component: () =>
            import(
                /* webpackChunkName: "station-management" */ "../pages/StationManagement/AddStation"
                ),
        meta: {
            active: "StationManagement",
            permissionCode: "admin:org:manager",
        },
    },
    // {
    //   path: "/unit-management",
    //   name: "UnitManagement",
    //   component: () =>
    //       import(/* webpackChunkName: "unit-management" */ "../pages/UnitManagement/"),
    //   meta: {
    //     active: "UnitManagement",
    //   },
    // },
    // {
    //   path: "/unit-management/add-unit/:id/:type",
    //   name: "AddUnit",
    //   component: () =>
    //       import(/* webpackChunkName: "unit-management" */ "../pages/UnitManagement/AddUnit"),
    //   meta: {
    //     active: "UnitManagement",
    //   },
    // },
    {
        path: "/personnel-management",
        name: "PersonnelManagement",
        component: () =>
            import(
                /* webpackChunkName: "personnel-management" */ "../pages/PersonnelManagement/"
                ),
        meta: {
            active: "PersonnelManagement",
            permissionCode: "admin:user",
        },
    },
    {
        path: "/personnel-management/add-person/:id/:type",
        name: "AddPerson",
        component: () =>
            import(
                /* webpackChunkName: "personnel-management" */ "../pages/PersonnelManagement/AddPerson"
                ),
        meta: {
            active: "PersonnelManagement",
            permissionCode: "admin:user:manager",
        },
    },
    {
        path: "/trainee-management",
        name: "TraineeManagement",
        component: () =>
            import(
                /* webpackChunkName: "trainee-management" */ "../pages/TraineeManagement/"
                ),
        meta: {
            active: "TraineeManagement",
            permissionCode: "admin:trainee",
        },
    },
    {
        path: "/classify-management",
        name: "ClassifyManagement",
        component: () =>
            import(
                /* webpackChunkName: "classify-management" */ "../pages/ClassifyManagement/"
                ),
        meta: {
            active: "ClassifyManagement",
            permissionCode: "research:dir",
        },
    },
    {
        path: "/classify-management/add-classify/:type/:id",
        name: "AddClassify",
        component: () =>
            import(
                /* webpackChunkName: "classify-management" */ "../pages/ClassifyManagement/AddClassify"
                ),
        meta: {
            active: "ClassifyManagement",
            permissionCode: "research:dir:manager",
        },
    },
    {
        path: "/tag-management",
        name: "TagManagement",
        component: () =>
            import(
                /* webpackChunkName: "tag-management" */ "../pages/TagManagement/"
                ),
        meta: {
            active: "TagManagement",
            permissionCode: "research:tag",
        },
    },
    {
        path: "/tag-management/add-tag/:type",
        name: "AddTag",
        component: () =>
            import(
                /* webpackChunkName: "tag-management" */ "../pages/TagManagement/AddTag"
                ),
        meta: {
            active: "TagManagement",
            permissionCode: "research:tag:manager",
        },
    },
    {
        path: "/tag-management/tag-attribute",
        name: "TagAttribute",
        component: () =>
            import(
                /* webpackChunkName: "tag-management" */ "../pages/TagManagement/TagAttribute"
                ),
        meta: {
            active: "TagManagement",
            permissionCode: "research:tag",
        },
    },
    {
        path: "/series-management",
        name: "SeriesManagement",
        component: () =>
            import(
                /* webpackChunkName: "series-management" */ "../pages/SeriesManagement/"
                ),
        meta: {
            active: "SeriesManagement",
            permissionCode: "research:subject",
        },
    },
    {
        path: "/series-management/add-enterprise-series/:type/:id",
        name: "AddEnterpriseSeries",
        component: () =>
            import(
                /* webpackChunkName: "series-management" */ "../pages/SeriesManagement/AddEnterpriseSeries"
                ),
        meta: {
            active: "SeriesManagement",
            permissionCode: "research:subject:manager",
        },
    },
    {
        path: "/approval-management",
        name: "ApprovalManagement",
        component: () =>
            import(
                /* webpackChunkName: "approval-management" */ "../pages/ApprovalManagement/"
                ),
        meta: {
            active: "ApprovalManagement",
            permissionCode: "research:approve",
        },
    },
    {
        path: "/approval-management/approval-course/:lessonId/:version",
        name: "ApprovalCourse",
        component: () =>
            import(
                /* webpackChunkName: "approval-management" */ "../pages/ApprovalManagement/ApprovalCourse"
                ),
        meta: {
            active: "ApprovalManagement",
            permissionCode: "research:approve:manager",
        },
    },
    {
        path: "/production-management",
        name: "ProductionManagement",
        component: () =>
            import(
                /* webpackChunkName: "approval-management" */ "../pages/ProductionManagement/"
                ),
        meta: {
            active: "ProductionManagement",
            permissionCode: "research:product",
        },
    },
    {
        path: "/bu-management",
        name: "BuManagement",
        component: () =>
            import(
                /* webpackChunkName: "approval-management" */ "../pages/BuManagement/"
                ),
        meta: {
            active: "BuManagement",
            permissionCode: "assist:depart",
        },
    },
    {
        path: "/bu-management/add-bu/:type/:id",
        name: "AddBuMen",
        component: () =>
            import(
                /* webpackChunkName: "series-management" */ "../pages/BuManagement/AddBuMen"
                ),
        meta: {
            active: "BuManagement",
            permissionCode: "assist:depart:manager",
        },
    },
    {
        path: "/role-management",
        name: "RoleManagement",
        component: () =>
            import(
                /* webpackChunkName: "approval-management" */ "../pages/RoleManagement/"
                ),
        meta: {
            active: "RoleManagement",
            permissionCode: "assist:role",
        },
    },
    {
        path: "/role-management/add-role/:type/:assistDepartId",
        name: "AddRole",
        component: () =>
            import(/* webpackChunkName: "role-management" */ "../pages/RoleManagement/AddRole"),
        meta: {
            active: "RoleManagement",
            permissionCode: "assist:role:manager",
        },
    },
    {
        path: "/work-order-management",
        name: "WorkOrderManagement",
        component: () =>
            import(/* webpackChunkName: "approval-management" */ "../pages/WorkOrderManagement/"),
        meta: {
            active: "WorkOrderManagement",
            permissionCode: "assist:work",
        },
    },
    {
        path: "/consulting-management",
        name: "ConsultingManagement",
        component: () =>
            import(/* webpackChunkName: "approval-management" */ "../pages/ConsultingManagement/"),
        meta: {
            active: "ConsultingManagement",
            permissionCode: "assist:consulting",
        },
    },
    {
        path: "/chat-doc-management",
        name: "ChatDocManagement",
        component: () =>
            import(/* webpackChunkName: "approval-management" */ "../pages/ChatDocManagement/"),
        meta: {
            active: "ChatDocManagement",
            permissionCode: "assist:chatDoc",
        },
    },
    {
        path: "/production-management/add-production/:type/:id",
        name: "AddProduction",
        component: () =>
            import(
                /* webpackChunkName: "series-management" */ "../pages/ProductionManagement/AddProduction"
                ),
        meta: {
            active: "ProductionManagement",
            permissionCode: "research:product:manager",
        },
    },
    {
        path: "/production-management/product-category",
        name: "productCategory",
        component: () =>
            import( "../pages/ProductionManagement/ProductCategory"),
        meta: {
            active: "ProductionManagement",
            permissionCode: "research:product:manager",
        },
    },
    {
        path: "/production-management/add-question-bank/:type/:id",
        name: "AddQuestionBank",
        component: () =>
            import(
                /* webpackChunkName: "series-management" */ "../pages/ProductionManagement/AddQuestionBank"
                ),
        meta: {
            active: "ProductionManagement",
            permissionCode: "research:product:manager",
        },
    },
    {
        path: "/material-center",
        name: "MaterialCenter",
        component: () =>
            import(
                /* webpackChunkName: "material-center" */ "../pages/MaterialCenter/"
                ),
        meta: {
            active: "MaterialCenter",
            permissionCode: "lesson:material",
        },
    },
    {
        path: "/task-management/:assistRoleId",
        name: "TaskManagement",
        component: () =>
            import(
                /* webpackChunkName: "material-center" */ "../pages/TaskManagement/"
                ),
        meta: {
            active: "RoleManagement",
            permissionCode: "assist:task",
        },
    },
    {
        path: "/course-management",
        name: "CourseManagement",
        component: () =>
            import(
                /* webpackChunkName: "course-management" */ "../pages/CourseManagement/"
                ),
        meta: {
            active: "CourseManagement",
            permissionCode: "lesson:manager",
        },
    },
    {
        path: "/course-management/course-list/:classSubjectId/:classSubjectName/:classTreeId",
        name: "CourseList",
        component: () =>
            import(
                /* webpackChunkName: "course-management" */ "../pages/CourseManagement/CourseList"
                ),
        meta: {
            active: "CourseManagement",
            permissionCode: "lesson:manager",
        },
    },
    {
        path: "/course-management/add-course/:type/:classSubjectId/:classSubjectName",
        name: "AddCourse",
        component: () =>
            import(
                /* webpackChunkName: "course-management" */ "../pages/CourseManagement/AddCourse"
                ),
        meta: {
            active: "CourseManagement",
            permissionCode: "lesson:manager:manager",
        },
    },
    {
        path: "/course-management/view-course/:lessonId/:version/:classSubjectId/:classSubjectName",
        name: "ViewCourse",
        component: () =>
            import(
                /* webpackChunkName: "course-management" */ "../pages/CourseManagement/ViewCourse"
                ),
        meta: {
            active: "CourseManagement",
            permissionCode: "lesson:manager",
        },
    },
    {
        path: "/course-management/add-outline/:lessonId/:classSubjectId/:classSubjectName/:type",
        name: "AddOutLine",
        component: () =>
            import(
                /* webpackChunkName: "course-management" */ "../pages/CourseManagement/AddOutLine"
                ),
        meta: {
            active: "CourseManagement",
            permissionCode: "lesson:manager:manager",
        },
    },
    {
        path: "/course-management/my-outline/:lessonId/:version/:classSubjectId/:classSubjectName/:type",
        name: "MyOutLine",
        component: () =>
            import(/* webpackChunkName: "course-management" */ "../pages/MyOutLine/"),
        meta: {
            active: "CourseManagement",
            permissionCode: "lesson:manager",
        },
    },
    {
        path: "/course-management/view-lessonContent/:lessonId/:version/:classSubjectId/:classSubjectName",
        name: "ViewLessonContent",
        component: () =>
            import(
                /* webpackChunkName: "course-management" */ "../pages/CourseManagement/ViewLessonContent"
                ),
        meta: {
            active: "CourseManagement",
            permissionCode: "lesson:manager",
        },
    },
    {
        path: "/question-management",
        name: "QuestionManagement",
        component: () =>
            import(
                /* webpackChunkName: "question-management" */ "../pages/QuestionManagement/"
                ),
        meta: {
            active: "QuestionManagement",
            permissionCode: "lesson:question",
        },
    },
    {
        path: "/mark-management",
        name: "MarkManagement",
        component: () =>
            import(
                /* webpackChunkName: "question-management" */ "../pages/MarkManagement/"
                ),
        meta: {
            active: "MarkManagement",
            permissionCode: "lesson:mark",
        },
    },
    {
        path: "/question-management/:lessonName",
        name: "LessonQuestionManagement",
        component: () =>
            import(
                /* webpackChunkName: "question-management" */ "../pages/QuestionManagement/"
                ),
        meta: {
            active: "CourseManagement",
            permissionCode: "lesson:question",
        },
    },
    {
        path: "/daily-clock",
        name: "DailyClock",
        component: () =>
            import(
                /* webpackChunkName: "question-management" */ "../pages/DailyClock/"
                ),
        meta: {
            active: "DailyClock",
            permissionCode: "plugin:knowledge",
        },
    },
    {
        path: "/question-bank",
        name: "QuestionBank",
        component: () =>
            import(
                /* webpackChunkName: "question-management" */ "../pages/QuestionBank/"
                ),
        meta: {
            active: "QuestionBank",
            permissionCode: "plugin:testPaper",
        },
    },
    {
        path: "/project-management",
        name: "ProjectManagement",
        component: () =>
            import(
                /* webpackChunkName: "question-management" */ "../pages/ProjectManagement/"
                ),
        meta: {
            active: "ProjectManagement",
            permissionCode: "plugin:project",
        },
    },
    {
        path: "/project-management/evaluation-list/:projectId",
        name: "ProjectEvaluationList",
        component: () =>
            import(
                /* webpackChunkName: "question-management" */ "../pages/ProjectManagement/ProjectEvaluationList.vue"
                ),
        meta: {
            active: "ProjectManagement",
            permissionCode: "plugin:project:list",
        },
    },
    {
        path: "/question-bank/test-paper-report/:testPaperId",
        name: "TestPaperReport",
        component: () =>
            import(
                /* webpackChunkName: "question-management" */ "../pages/QuestionBank/TestPaperReport"
                ),
        meta: {
            active: "QuestionBank",
            permissionCode: "plugin:testPaper:list",
        },
    },
    {
        path: "/add-clock/:type/:id",
        name: "AddClock",
        component: () =>
            import(
                /* webpackChunkName: "question-management" */ "../pages/DailyClock/AddClock"
                ),
        meta: {
            active: "DailyClock",
            permissionCode: "plugin:knowledge:manager",
        },
    },
    {
        path: "/order-management",
        name: "OrderManagement",
        component: () =>
            import(
                /* webpackChunkName: "order-management" */ "../pages/OrderManagement/"
                ),
        meta: {
            active: "OrderManagement",
            permissionCode: "affairs:order",
        },
    },
    {
        path: "/tenant-management",
        name: "TenantManagement",
        component: () =>
            import(
                /* webpackChunkName: "order-management" */ "../pages/TenantManagement/"
                ),
        meta: {
            active: "TenantManagement",
            permissionCode: "affairs:tenant",
        },
    },
    {
        path: "/tenant-management/copy-tenant-lesson/:tenantId",
        name: "CopyTenantLesson",
        component: () =>
            import(
                /* webpackChunkName: "order-management" */ "../pages/TenantManagement/CopyTenantLesson.vue"
                ),
        meta: {
            active: "TenantManagement",
            permissionCode: "affairs:tenant",
        },
    },
    {
        path: "/tenant-management/copy-tenant-test-paper/:tenantId",
        name: "CopyTenantTestPaper",
        component: () =>
            import(
                /* webpackChunkName: "order-management" */ "../pages/TenantManagement/CopyTenantTestPaper.vue"
                ),
        meta: {
            active: "TenantManagement",
            permissionCode: "affairs:tenant",
        },
    },
    {
        path: "/teaching-data",
        name: "TeachingData",
        component: () =>
            import(/* webpackChunkName: "teacher-data" */ "../pages/TeachingData/"),
        meta: {
            active: "TeachingData",
            permissionCode: "data:lesson",
        },
    },
    {
        path: "/teaching-data/report-list/:id",
        name: "ReportList",
        component: () =>
            import(
                /* webpackChunkName: "question-management" */ "../pages/TeachingData/ReportList"
                ),
        meta: {
            active: "TeachingData",
            permissionCode: "data:lesson",
        },
    },
    {
        path: "/teaching-data/marking-list/:id",
        name: "MarkingList",
        component: () =>
            import(
                /* webpackChunkName: "question-management" */ "../pages/TeachingData/MarkingList"
                ),
        meta: {
            active: "TeachingData",
            permissionCode: "data:lesson",
        },
    },
    {
        path: "/student-data",
        name: "StudentData",
        component: () =>
            import(/* webpackChunkName: "student-data" */ "../pages/StudentData/"),
        meta: {
            active: "StudentData",
            permissionCode: "data:trainee",
        },
    },
    {
        path: "/learning-detail",
        name: "LearningDetail",
        component: () =>
            import(/* webpackChunkName: "student-data" */ "../pages/LearningDetail/"),
        meta: {
            active: "LearningDetail",
            permissionCode: "data:detail",
        },
    },
    {
        path: "/learning-detail/learning-info/:userId",
        name: "LessonLearningView",
        component: () =>
            import(
                /* webpackChunkName: "trainee-management" */ "../pages/LearningDetail/LessonLearningList"
                ),
        meta: {
            active: "LearningDetail",
            permissionCode: "data:detail",
        },
    },
    {
        path: "/learning-detail/test-info/:userId",
        name: "TestInfoView",
        component: () =>
            import(
                /* webpackChunkName: "trainee-management" */ "../pages/LearningDetail/TestInfoList.vue"
                ),
        meta: {
            active: "LearningDetail",
            permissionCode: "data:detail",
        },
    },
    {
        path: "/accountBinding/:authUnionId",
        name: "AccountBinding",
        component: () =>
            import(/* webpackChunkName: "login" */ "../pages/AccountBinding/"),
        meta: {
            noAppNav: true,
        },
    },
    {
        path: "/login",
        name: "Login",
        component: () => import(/* webpackChunkName: "login" */ "../pages/Login/"),
        meta: {
            noAppNav: true,
        },
    },
    {
        path: "/register",
        name: "Register",
        component: () => import(/* webpackChunkName: "login" */ "../pages/Login/register"),
        meta: {
            noAppNav: true,
        },
    },
    {
        path: "*", // 此处需特别注意至于最底部
        redirect: "/404",
    },
];

const router = new VueRouter({
    routes,
});

export default router;
